import { Btn, LoaderPanel, PanelCenter, BtnVariants } from 'mga-commons'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { FaAngleDoubleDown } from '@react-icons/all-files/fa/FaAngleDoubleDown'
import { FaSearch } from '@react-icons/all-files/fa/FaSearch'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import PanelRead from '../../../components/commons/PanelRead'
import CardSearch from '../../../components/anonymous/search/CardSearch'
import CardSearchMobile from '../../../components/anonymous/search/CardSearchMobile'
import { anonymousFicheGetItems, selectIsLoading, selectIsLoadingMore, selectSearchData } from '../../../slices/anonymous/anonymousFicheSlice'
import { EnumTypeMedecin, EnumWilaya } from '../../../utils/generated/Constants'
import { FichesToMeta } from '../../../utils/JsonLdUtils'
import { useMobileQuery } from '../../../utils/MediaQueries'
import './PageSearchWilayaSpecialite.css'

const PageSearchWilayaSpecialite = () => {

    const isMobile = useMobileQuery()
    const dispatch = useDispatch()
    const params = useParams();

    const searchData = useSelector(selectSearchData)
    const isLoading = useSelector(selectIsLoading)
    const isLoadingMore = useSelector(selectIsLoadingMore)

    const canLoadMore = searchData?.CanLoadMore
    const items = searchData?.Items

    let wilayaIndex = params.w;
    let specialiteIndex = params.s;

    let wilayaTmp = Object.values(EnumWilaya).find((item) => item.Code.toString() === wilayaIndex)
    let specTmp = Object.values(EnumTypeMedecin).find((item) => item.Code.toString() === specialiteIndex)

    useEffect(() => {

        // Load data
        dispatch(anonymousFicheGetItems({
            params: {
                text: null,
                idWilaya: wilayaTmp.Code,
                idTypeMedecin: specTmp.Code,
                idTypeEtablissement: null,
                idTypeService: null,
                from: 0
            }
        }))

    }, [wilayaIndex, specialiteIndex])

    const handleLoadMore = () => {

        // Load data
        dispatch(anonymousFicheGetItems({
            params: {
                text: null,
                idWilaya: wilayaTmp.Code,
                idTypeMedecin: specTmp.Code,
                idTypeEtablissement: null,
                idTypeService: null,
                from: items.length
            }
        }))

    }

    let title = specTmp.Libelle + ' dans la ' + wilayaTmp.LibelleLong.lowerFirstLetter()
    let keywords = 'specialite, medicale, medecin, docteur, hopital, wilaya, algerie, urologue, neurologue,' + wilayaTmp.LibelleLong + ', ' + specTmp.Libelle

    let schema = FichesToMeta(items)


    if (isLoading) {
        return <LoaderPanel margin="60px" />
    }

    const isEmpty = !isLoadingMore && ((items || []).length === 0)

    return (
        <div className="page-search-wilaya-specialite">
            <Helmet script={schema}>
                <title>{title}</title>
                <meta name="description" content={title} />
                <meta name="keywords" content={keywords} />
                <link rel="canonical" href={window.location.origin + '/search-wilaya-specialite'} />
            </Helmet>
            <PanelRead>
                <h1 className="title">
                    <FaSearch />
                    Spécialistes en {title}
                </h1>
                <div className="items">
                    {(items || []).map((item, index) => isMobile ? <CardSearchMobile key={'fiche' + item.IdFiche} item={item} /> : <CardSearch key={'fiche' + item.IdFiche} item={item} />)}
                </div>
                {
                    canLoadMore &&
                    <PanelCenter>
                        <Btn variant={BtnVariants.SecondaryOutline} isEnabled={!isLoadingMore} minWidth="300px" onClick={handleLoadMore}>
                            <FaAngleDoubleDown size="22" />
                            &nbsp;&nbsp;&nbsp;
                            <strong>Voir plus</strong>
                        </Btn>
                    </PanelCenter>
                }
                {
                    isEmpty && <div style={{ textAlign: 'center', padding: '40px' }}>
                        <h2>Aucun résultat trouvé !</h2>
                        <h4>Veuillez réessayer ...</h4>
                    </div>
                }
                <br />
                <br />
            </PanelRead>
        </div>

    )
}

export default PageSearchWilayaSpecialite